import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import useToggleMenu from '../../../hooks/useToggleMenu'
import ActivityIcon from '../../Activity/ActivityIcon'
import Button from '../../../../common/components/Button'
import Icon from '../../../../common/components/Icon'
import Row, { RowButton, RowSet } from '../../../../common/components/Row'
import Text from '../../../../common/components/Text'
import AccountMenu from '../AccountMenu'
import { LabelGroup } from '../../../../common/components/Label/Label'
// import CreateBoardButton from '../../../../common/components/CreateBoardButton'

const WiipButton = () => {
  const { t } = useTranslation()
  return (
    <RowButton flex to="/">
      <Icon icon="circle" />
      <Text medium>
        {t('productName')}
        {t('environmentQualifier')}
      </Text>
    </RowButton>
  )
}

const HomeButton = props => {
  const { t } = useTranslation()
  return (
    <RowButton flex {...props}>
      <Icon icon="arrow-left" />
      <Text medium>{t('sidebar.home')}</Text>
    </RowButton>
  )
}

const AccountButton = ({ onClick, userName }) => (
  <RowButton flex onClick={onClick}>
    <Icon icon="arrowhead-down" />
    <Text medium>{userName}</Text>
  </RowButton>
)

const TopBar = ({ userName, anon, inFolder, closeable, toggleSidebar }) => {
  const accountMenuRef = useRef()
  const [accountMenuOpen, showAccountMenu, hideAccountMenu] = useToggleMenu(
    accountMenuRef
  )
  const { t } = useTranslation()
  return (
    <>
      <RowSet>
        {anon ? (
          <WiipButton />
        ) : inFolder ? (
          <HomeButton to="/" />
        ) : (
          <AccountButton userName={userName} onClick={showAccountMenu} />
        )}
        <Row>
          <LabelGroup>
            {/* <CreateBoardButton /> */}
            <ActivityIcon />
            <Button
              disabled={!closeable}
              onClick={closeable ? toggleSidebar : undefined}
              tooltip={t('sidebar.tooltips.closeSidebar')}
            >
              <Icon icon="x" />
            </Button>
          </LabelGroup>
        </Row>
      </RowSet>

      {accountMenuOpen && (
        <AccountMenu hide={hideAccountMenu} menuRef={accountMenuRef} />
      )}
    </>
  )
}

export default TopBar
